// Media
export const REQUEST_MEDIA = "REQUEST_MEDIA";
export const RECIEVE_MEDIA = "RECIEVE_MEDIA";
export const SELECT_MEDIA = "SELECT_MEDIA";
export const DESELECT_MEDIA = "DESELECT_MEDIA";
export const SELECT_ALL_MEDIA = "SELECT_ALL_MEDIA";
export const DESELECT_ALL_MEDIA = "DESELECT_ALL_MEDIA";
export const REQUEST_DELETE_MEDIA = "REQUEST_DELETE_MEDIA";
export const RECIEVE_DELETE_MEDIA = "RECIEVE_DELETE_MEDIA";
export const REQUEST_ADD_MEDIA = "REQUEST_ADD_MEDIA";
export const RECIEVE_ADD_MEDIA = "RECIEVE_ADD_MEDIA";
export const REQUEST_UPDATE_MEDIA = "REQUEST_UPDATE_MEDIA";
export const RECIEVE_UPDATE_MEDIA = "RECIEVE_UPDATE_MEDIA";
export const SET_PREVIEW_MEDIA_SOURCE = "SET_PREVIEW_MEDIA_SOURCE";
export const SET_MEDIA_ROW_OBJECT = "SET_MEDIA_ROW_OBJECT";
export const REQUEST_MEDIA_SEARCH = "REQUEST_MEDIA_SEARCH";
export const RECEIVE_MEDIA_SEARCH = "RECEIVE_MEDIA_SEARCH";

//Skill Details
export const UPDATE_ADD_SKILL_DETAILS_VALUES = "UPDATE_ADD_SKILL_DETAILS_VALUES";
export const REQUEST_ADD_SKILL_DETAILS = "REQUEST_ADD_SKILL_DETAILS";
export const RECEIVE_ADD_SKILL_DETAILS = "RECEIVE_ADD_SKILL_DETAILS";
export const CLEAR_ADD_SKILL_DETAILS_VALUES = "CLEAR_ADD_SKILL_DETAILS_VALUES";

// Media Reprocessing
export const REQUEST_MEDIA_REPROCESSING = "REQUEST_MEDIA_REPROCESSING";
export const RECIEVE_MEDIA_REPROCESSING = "RECIEVE_MEDIA_REPROCESSING";
export const REQUEST_DATASET_REPROCESSING = "REQUEST_DATASET_REPROCESSING";
export const RECIEVE_DATASET_REPROCESSING = "RECIEVE_DATASET_REPROCESSING";
export const REQUEST_SCENE_REPROCESSING = "REQUEST_SCENE_REPROCESSING";
export const RECIEVE_SCENE_REPROCESSING = "RECIEVE_SCENE_REPROCESSING";

// Scene Search in Nav
export const SET_CURRENT_SCENE = 'SET_CURRENT_SCENE';
export const REQUEST_SCENES = 'REQUEST_SCENES';
export const RECIEVE_SCENES = 'RECIEVE_SCENES';

//UI
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const REQUEST_SOURCE_MEDIA_FOR_PREVIEW = "REQUEST_SOURCE_MEDIA_FOR_PREVIEW";
export const RECEIVE_SOURCE_MEDIA_FOR_PREVIEW = "RECEIVE_SOURCE_MEDIA_FOR_PREVIEW";
export const CLEAR_SOURCE_MEDIA_PREVIEW_VALUES = "CLEAR_SOURCE_MEDIA_PREVIEW_VALUES";
export const UPDATE_ADD_MEDIA_VALUES = "UPDATE_ADD_MEDIA_VALUES";
export const CLEAR_ADD_MEDIA_VALUES = "CLEAR_ADD_MEDIA_VALUES";
export const START_CSV_PROCESSING = "START_CSV_PROCESSING";
export const END_CSV_PROCESSING = "END_CSV_PROCESSING";
export const ADD_CSV_PROCESSING_RESULT = "ADD_CSV_PROCESSING_RESULT";
export const CLEAR_CSV_PROCESSING_RESULTS = "CLEAR_CSV_PROCESSING_RESULTS";
export const INITIALIZE_CSV_PROCESSING_RESULTS = "INITIALIZE_CSV_PROCESSING_RESULTS";

// Bundles
export const REQUEST_BUILD_BUNDLES = "REQUEST_BUILD_BUNDLES";
export const RECEIVE_BUILD_BUNDLES = "RECEIVE_BUILD_BUNDLES";
export const UPDATE_BUILD_BUNDLES_VALUES = "UPDATE_BUILD_BUNDLES_VALUES";
export const CLEAR_BUILD_BUNDLES_VALUES = "CLEAR_BUILD_BUNDLES_VALUES";

// Create Activity
export const UPDATE_CREATE_ACTIVITY_VALUES = "UPDATE_CREATE_ACTIVITY_VALUES";
export const CLEAR_CREATE_ACTIVITY_VALUES = "CLEAR_CREATE_ACTIVITY_VALUES";
export const REQUEST_CREATE_ACTIVITY    = "REQUEST_CREATE_ACTIVITY";
export const RECEIVE_CREATE_ACTIVITY    = "RECEIVE_CREATE_ACTIVITY";

// Create Skill
export const UPDATE_CREATE_SKILL_VALUES = "UPDATE_CREATE_SKILL_VALUES";
export const CLEAR_CREATE_SKILL_VALUES = "CLEAR_CREATE_SKILL_VALUES";
export const REQUEST_CREATE_SKILL    = "REQUEST_CREATE_SKILL";
export const RECEIVE_CREATE_SKILL    = "RECEIVE_CREATE_SKILL";

// Create Skill Group
export const UPDATE_CREATE_SKILL_GROUP_VALUES = "UPDATE_CREATE_SKILL_GROUP_VALUES";
export const CLEAR_CREATE_SKILL_GROUP_VALUES = "CLEAR_CREATE_SKILL_GROUP_VALUES";
export const REQUEST_CREATE_SKILL_GROUP    = "REQUEST_CREATE_SKILL_GROUP";
export const RECEIVE_CREATE_SKILL_GROUP    = "RECEIVE_CREATE_SKILL_GROUP";

//Skills
export const REQUEST_ALL_SKILLS = "REQUEST_ALL_SKILLS";
export const RECEIVE_ALL_SKILLS = "RECEIVE_ALL_SKILLS";
export const REQUEST_SKILL = "REQUEST_SKILL";
export const RECEIVE_SKILL = "RECEIVE_SKILL";
export const REQUEST_ACTIVITY_SKILLS = "REQUEST_ACTIVITY_SKILLS";
export const RECEIVE_ACTIVITY_SKILLS = "RECEIVE_ACTIVITY_SKILLS";
export const REQUEST_ALL_SKILL_GROUPS = "REQUEST_ALL_SKILL_GROUPS";
export const RECEIVE_ALL_SKILL_GROUPS = "RECEIVE_ALL_SKILL_GROUPS";

//Nav
export const SET_PAGE = "SET_PAGE";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js